import { Store_Location_Evaluation_Method } from '@occc/graphql';

export const evaluationMethodOptions: { title: string; value: Store_Location_Evaluation_Method }[] =
  [
    {
      title: 'Include',
      value: Store_Location_Evaluation_Method.Include,
    },
    {
      title: 'Exclude',
      value: Store_Location_Evaluation_Method.Exclude,
    },
  ];
